import React, { useEffect } from 'react';
import { NavLink } from "react-router-dom";
import './perfil.scss';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { Testimonials, SectionComments, Layout, TitleSecondary, AdBlock, AdImage } from '../../components';
import data from "../../data/data.json";

const PerfilPrestador = ({ image, name, occupation, price, location }) => {

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">
            <div className="profile">
                <div className="profile-container">
                    <div className="profile-card">
                        {/* <NavLink className="profile-button-back" to="/">
                    <i class="fas fa-chevron-circle-left"></i>
                    <span className="button-back-text">volver</span>
                </NavLink> */}

                        <div className="profile-img-container">
                            <img className="profile-img" src={location.state.image} alt={name} />
                        </div>
                        <div className="profile-info">

                            <div className="profile-name">
                                {location.state.name &&
                                    location.state.name[0].toUpperCase() +
                                    location.state.name.slice(1, location.state.name.indexOf(" ")) +
                                    " " +
                                    location.state.name[location.state.name.indexOf(" ") + 1].toUpperCase() +
                                    location.state.name.slice(location.state.name.indexOf(" ") + 2)}
                            </div>
                            {/* <span className="profile-rating">
                        <RatingStars rating={rating} />
                    </span> */}
                            <div className="profile-zone">
                                Electricista
                            </div>
                            <p className="profile-description">
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui nihil pariatur laudantium a expedita nemo repellat atque consequatur temporibus provident.
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Qui nihil pariatur laudantium a expedita nemo repellat atque consequatur temporibus provident.
                            </p>
                            <div className="profile__item">
                                <span>Zona de trabajo: </span>CABA
                            </div>
                            <div className="profile__item">
                                <span>Garantía: </span>Garantía de mano de obra de 180 días desde la terminación del trabajo.
                            </div>
                            <div className="profile__item">
                                <span>Especialidades: </span>Instalación electrica en el hogar
                            </div>
                            <div className="profile__item">
                                <span>Trabajos realizados dentro de la plataforma: </span>5
                            </div>
                            <div className="profile__item">
                                <span>Titulos: </span>Tecnico mecanico - Universidad de la plata
                            </div>
                            <div className="profile__item">
                                <span>cursos: </span>Lorem ipsum dolor sit amet consectetur adipisicing elit.
                            </div>
                            <div className="profile__item">
                                <span>Reputación: </span>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <a className="profile-button" href="https://api.whatsapp.com/send?phone=5491133236103&text=Hola!%20vi%20tu%20perfil%20en%20Solucionarte!%20Me%20gustaría%20realizar%20una%20consulta.">
                                <i class="fab fa-whatsapp"></i>
                                <span className="profile-button-text">CONTRATAR</span>
                            </a>
                        </div>
                    </div>

                    <div className="profile__info">
                        <div className="profile__info--content">
                            <div className="profile__data">
                                <TitleSecondary align="left">Servicios</TitleSecondary>
                                <span>
                                    <ul>
                                        <li>Instalación de Teclas y tomacorrientes</li>
                                        <li>Cambio de Teclas y tomacorrientes</li>
                                        <li>Instalación de Artefactos de iluminación</li>
                                        <li>Cambio de Artefactos de iluminación</li>
                                        <li>Instalación de Cocina electrica</li>
                                        <li>Instalación de Termotanque electrico</li>
                                        <li>Instalación de Estufa electrica</li>
                                        <li>Cableados</li>
                                        <li>Armado de tableros</li>
                                    </ul>
                                </span>
                            </div>

                            <div className="profile__data">
                                <TitleSecondary align="left">Precios de referencia</TitleSecondary>
                                <span>
                                    Habilitación: $6500 - $9000
                                </span>
                            </div>

                            <div className="profile__data">
                                <TitleSecondary align="left">Matricula</TitleSecondary>
                                <span>
                                    Electricista matriculado 1ra. categoría. Naturgy BAN
                                </span>
                            </div>

                            <div className="profile__data">
                                <TitleSecondary align="left">Otras</TitleSecondary>
                                <span>
                                    Responsabilidad, experiencia, profesionalismo, puntualidad y auto-exigencia, son mis credenciales de presentación. Precios accesibles. Trabajo a conciencia, respetando el reglamento. Soy profesional de mi profesión y exigente. Lo intento día a día. De Zárate a La Plata y desde el río hasta Luján o más lejos. Lo intento día a día. De Zárate a La Plata o más lejos.
                                </span>
                            </div>
                        </div>

                        <div className="profile__info--ad">
                            <AdBlock>
                                <AdImage width="300px" height="250px" />
                            </AdBlock>
                            <AdBlock>
                                <AdImage width="300px" height="250px" />
                            </AdBlock>
                            <AdBlock>
                                <AdImage width="300px" height="250px" />
                            </AdBlock>
                        </div>
                    </div>



                    <div className="profile__testimonials">
                        <SectionComments />
                    </div>

                    <AdBlock>
                        <AdImage width="728px" height="90px" />
                    </AdBlock>

                </div>
            </div>
        </Layout>
    )
}

export default PerfilPrestador
